import { render, staticRenderFns } from "./Usps.vue?vue&type=template&id=a07789d4"
import script from "./Usps.vue?vue&type=script&lang=js"
export * from "./Usps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports